import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=3b62611b"
import script from "./commentList.vue?vue&type=script&lang=js"
export * from "./commentList.vue?vue&type=script&lang=js"
import style0 from "./commentList.vue?vue&type=style&index=0&id=3b62611b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports